/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import OutlinePlusIcon from '../../../commonComponents/icons/OutlinePlusIcon';

function BinaryTreeButtons({
  t,
  idx,
  users,
  setSelectedUser,
  selectedUserPerLevel,
  onOpenModal,
  isLeft,
  isManualPlaceUserBehaviourAllowed,
}) {
  const showLeft =
    !users[idx].users.length ||
    (users[idx].users[0].directSelling.binarySide === 'right' &&
      !(users[idx]?.users[1]?.directSelling?.binarySide === 'left'));
  const showRight =
    !users[idx].users.length ||
    (users[idx].users[0].directSelling.binarySide === 'left' &&
      !(users[idx]?.users[1]?.directSelling?.binarySide === 'right'));
  return (
    <>
      {isLeft && showLeft && (
        <button
          type="button"
          className="binary-tree-button"
          onClick={() => {
            setSelectedUser(selectedUserPerLevel[idx - 1].user);
            onOpenModal('left', selectedUserPerLevel[idx - 1].user);
          }}
          disabled={!isManualPlaceUserBehaviourAllowed}
        >
          {isManualPlaceUserBehaviourAllowed && (
            <div>
              <OutlinePlusIcon />
              <p className="binary-button-text">{t('add_user')}</p>
            </div>
          )}
        </button>
      )}
      {!isLeft && showRight && (
        <button
          type="button"
          className="binary-tree-button"
          onClick={() => {
            setSelectedUser(selectedUserPerLevel[idx - 1].user);
            onOpenModal('right', selectedUserPerLevel[idx - 1].user);
          }}
          disabled={!isManualPlaceUserBehaviourAllowed}
        >
          {isManualPlaceUserBehaviourAllowed && (
            <div>
              <OutlinePlusIcon />
              <p className="binary-button-text">{t('add_user')}</p>
            </div>
          )}
        </button>
      )}
    </>
  );
}

BinaryTreeButtons.propTypes = {
  t: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  users: PropTypes.shape([]).isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  selectedUserPerLevel: PropTypes.shape([]).isRequired,
  isLeft: PropTypes.bool.isRequired,
  isManualPlaceUserBehaviourAllowed: PropTypes.bool,
};

BinaryTreeButtons.defaultProps = {
  isManualPlaceUserBehaviourAllowed: false,
};

export default BinaryTreeButtons;
